import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, forwardRef } from 'react'

// import loader5D from '../assets/icons/5D_loading.gif'
// import loader10D from '../assets/icons/10D_loading.gif'
// import loader20D from '../assets/icons/5D_loading.gif'
// import loader50D from '../assets/icons/5D_loading.gif'
// import loader100D from '../assets/icons/5D_loading.gif'

//import loader5D from '../assets/icons/spinner_bird5.svg'

//export default function ButtonTextIcon({text, icon, iconSize, ...restProps}) {
export default function Spinner(props) {
//const Spinner = ({text, icon, iconSize, ...restProps}) => {
// const ButtonTextIcon = forwardRef((props,ref) => {
    //console.log(props);
  return (

    <div className='grid h-full place-items-center'>
            {/* <button type="button" class="" disabled> */}

{/* animate-ping */}
        {/* {props.icon ?
        // <>
        <img src={props.icon} className="absolute animate-ping h-12 w-12 "/>
        // <img src={props.icon} className="absolute h-10 w-10 "/>
        // </>
        : 
        <svg className="absolute animate-ping h-7 w-7 mr-3 " viewBox="0 0 24 24">
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="transparent"
            ></circle>
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg> 
      } */}
      <div className='flex flex-col text-center content-center justify-center items-center'>
      <img src={props.icon} className="animate-pingfade h-24 w-24 "/>
          {/* </button> */}
      { props.text && 
        <p className='text-xs'>
        {props.text}     
        { (props.countermax && props.countermax.current > 0) &&
        <span>{props.counter}/{props.countermax.current}</span>
        }   
        </p>}
      
      </div>

    </div>
  )
}